import { Grid, Row, Col, Brand } from '@mcafee/pegasus';

/**
 * Generic mobile header component for all partners (T-Mobile, Metro, etc.)
 */
export default function MobileHeader() {
  return (
    <Grid className="ma-header-background">
      <Row className="bg-black">
        <Col xs={5} sm={5} md={4} lg={4} className="header-logo-conatainer flex direction-row align-items-center py-32">
          <Brand className="header-logo-conatainer" />
        </Col>
        <Col xs={3} sm={3} md={4} lg={4}></Col>
      </Row>
    </Grid>
  );
}
